var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpCenterProjectsAccess(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16659 1.16675H3.49992C3.1905 1.16675 2.89375 1.28966 2.67496 1.50846C2.45617 1.72725 2.33325 2.024 2.33325 2.33341V11.6667C2.33325 11.9762 2.45617 12.2729 2.67496 12.4917C2.89375 12.7105 3.1905 12.8334 3.49992 12.8334H10.4999C10.8093 12.8334 11.1061 12.7105 11.3249 12.4917C11.5437 12.2729 11.6666 11.9762 11.6666 11.6667V4.66675M8.16659 1.16675L11.6666 4.66675M8.16659 1.16675V4.66675H11.6666M9.33325 7.58342H4.66659M9.33325 9.91675H4.66659M5.83325 5.25008H4.66659",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCenterProjectsAccess);
export default __webpack_public_path__ + "static/media/help-center-projects-access.1861af5ca408ce98bcab0fc312ef0b13.svg";
export { ForwardRef as ReactComponent };